import { render, staticRenderFns } from "./RoleAccessTable.vue?vue&type=template&id=f9adc106"
import script from "./RoleAccessTable.vue?vue&type=script&lang=js"
export * from "./RoleAccessTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports